import { getPrescription } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { PrescriptionT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchPrescription(
  userId: string,
  dosespotPrescriptionId: string,
  signal?: AbortSignal
): Promise<PrescriptionT | null> {
  const config = await createLotusRequestConfig({ signal });
  const response = await getPrescription(userId, dosespotPrescriptionId, config);
  return lotusHealthZod.getPrescriptionResponse.parse(response.data) as PrescriptionT | null;
}
